<div class="status-progress__content-source">
  <ng-content select="sc-status-progress-item"></ng-content>
</div>

@if (projectedItems.length) {
  <div class="status-progress" role="list" aria-label="Progress status">
    <div class="status-progress__track">
      <div class="status-progress__track-line" [style.width]="trackLineWidth"></div>
      <div class="status-progress__track-line status-progress__track-line--active" [style.width]="activeTrackWidth"></div>
    </div>

    @for (item of projectedItems; track item.value ?? $index; let index = $index) {
      <div
        class="status-progress__step"
        [class.status-progress__step--first]="isFirst(index)"
        [class.status-progress__step--last]="index === projectedItems.length - 1"
        [class.status-progress__step--clickable]="isClickable(item)"
        [style.left]="getStepPosition(index)"
        (click)="onItemClick(item)"
        role="listitem">
        <div
          class="status-progress__dot"
          [class.status-progress__dot--last]="isLast(index) && lastLabelHalfWidthPx > 0"
          [style.left]="getDotLeft(index)"
          [class.status-progress__dot--active]="isActive(item)"
          [attr.aria-current]="item.active ? 'step' : null"></div>

        <div
          #labelRef
          class="status-progress__label small"
          [class.status-progress__label--active]="item.active"
          [class.status-progress__label--clickable]="isClickable(item)"
          [class.text-muted]="!isActive(item)">
          {{ item.label }}
        </div>
      </div>
    }
  </div>
}
